export * from "./index";
import { path } from ".";
import { pathFn } from ".";
import { wildcard } from ".";
import { isPath } from ".";
import { engine, update } from "./engine";
import { producers } from "./producers";

//This is for bundlers that are not very smart :(
export default {
	engine,
	update,
	producers,
	isPath,
	path,
	pathFn,
	wildcard,
};
